(function () {
  function getLangForCountry(countryCode) {
    return countryCode === 'IT' ? 'it' : 'en';
  }

  // --- Offcanvas ---
  function initOffcanvas() {
    var countrySelect = document.getElementById('localization-country');
    var langSelect = document.getElementById('localization-language');
    if (!countrySelect || !langSelect) return;

    var INTL_LANGS = ['en', 'fr', 'de', 'es'];

    // Elenco completo delle lingue, salvato prima di qualunque filtro: la select
    // viene ripopolata da qui a ogni cambio paese.
    var ALL_LANGS = Array.from(langSelect.options).map(function (opt) {
      return { value: opt.value, label: opt.textContent };
    });

    // Le opzioni non ammesse vanno RIMOSSE dal DOM, non nascoste: su iOS Safari la
    // select e' un picker nativo di sistema che ignora `hidden`/`display:none` sulle
    // <option>, percio' in mercato IT l'iPhone mostrava anche le lingue estere.
    function updateLangSelect(countryCode) {
      var isItaly = countryCode === 'IT';
      var wanted = isItaly ? 'it' : langSelect.value;
      if (!isItaly && !INTL_LANGS.includes(wanted)) wanted = 'en';

      langSelect.textContent = '';
      ALL_LANGS.forEach(function (lang) {
        var allowed = isItaly ? lang.value === 'it' : lang.value !== 'it';
        if (!allowed) return;
        var opt = document.createElement('option');
        opt.value = lang.value;
        opt.textContent = lang.label;
        if (lang.value === wanted) opt.selected = true;
        langSelect.appendChild(opt);
      });
    }

    var currentLang = langSelect.dataset.currentLang || langSelect.dataset.currentCountry;
    langSelect.value = currentLang;
    updateLangSelect(langSelect.dataset.currentCountry);

    countrySelect.addEventListener('change', function () {
      updateLangSelect(this.value);
    });
  }

  // --- Footer ---
  function initFooter() {
    var langContainer = document.querySelector('.cambiolingua[data-current-country]');
    if (langContainer) {
      var isItaly = langContainer.dataset.currentCountry === 'IT';
      langContainer.querySelectorAll('[name="language_code"]').forEach(function (btn) {
        btn.closest('li').hidden = isItaly ? btn.value !== 'it' : btn.value === 'it';
      });
    }

    document.querySelectorAll('[name="country_code"][type="submit"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = this.closest('form');
        if (!form) return;
        var lang = getLangForCountry(this.value);
        var existing = form.querySelector('input[type="hidden"][name="language_code"]');
        if (existing) {
          existing.value = lang;
        } else {
          var hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'language_code';
          hidden.value = lang;
          form.appendChild(hidden);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initOffcanvas();
    initFooter();
  });
})();
